import { render, staticRenderFns } from "./VaList.vue?vue&type=template&id=96a35f56&"
import script from "./VaList.vue?vue&type=script&lang=js&"
export * from "./VaList.vue?vue&type=script&lang=js&"
import style0 from "./VaList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports